import script from "./productionProcess.vue?vue&type=script&setup=true&lang=ts"
export * from "./productionProcess.vue?vue&type=script&setup=true&lang=ts"

import "./productionProcess.vue?vue&type=style&index=0&id=756de34a&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-756de34a"]])

export default __exports__